<template>
  <div class="page-content">
    <div class="flex header">
      <section>
        <img src="../assets/imgs/logo.png">
      </section>
      <section>{{ member.userName }}</section>
      <!-- <section style="font-size:0.8rem;">2019-11-12 15:20:30</section> -->
      <div class="login-out">
        <i class="iconfont tuichu" @click="onMemberOut"></i>
      </div>
    </div>
    <div class="flex function-content">
      <div class="content-title">
        <label>基本功能</label>
      </div>
      <div class="content-main">
        <section @click="goTargetPage('print')">
                    <span>
                        <i class="iconfont dayin"></i>
                    </span>
          <span>打印</span>
        </section>
        <section @click="goTargetPage('search')">
                    <span>
                        <i class="iconfont sousuo"></i>
                    </span>
          <span>查询</span>
        </section>
      </div>
    </div>
    <div class="flex tools">
      <div class="content-title">
        <label>工具箱</label>
      </div>
      <div class="content-main">
        <section>
          <label class="tool-item" @click="goTargetPage('receiving')">
                        <span>
                            <i class="iconfont daishouhuo-"></i>
                        </span>
            <span>收货</span>
          </label>
        </section>
        <section>
          <label class="tool-item" @click="goTargetPage('goodsShelves')">
                        <span>
                            <i class="iconfont shangjia"></i>
                        </span>
            <span>上架</span>
          </label>
        </section>
        <section>
          <label class="tool-item" @click="goTargetPage('picking')">
                        <span>
                            <i class="iconfont jianhuo"></i>
                        </span>
            <span>拣货</span>
          </label>
        </section>
        <section>
          <label class="tool-item" @click="goTargetPage('stockMove')">
                        <span>
                            <i class="iconfont diaobo"></i>
                        </span>
            <span>移位</span>
          </label>
        </section>
        <section>
          <label class="tool-item" @click="goTargetPage('checkStock')">
                        <span>
                            <i class="iconfont PDA"></i>
                        </span>
            <span>盘点</span>
          </label>
        </section>
        <section>
          <label class="tool-item" @click="goTargetPage('orderCancel')">
                        <span>
                            <i class="iconfont lkchedan"></i>
                        </span>
            <span>撤单</span>
          </label>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
import StorageUtil from "../util/storage.js";
import {connectSSE, closeSSE} from '../util/sse'

export default {
  data() {
    return {
      member: {}
    };
  },
  mounted() {
    this.member = StorageUtil.getLocalStorage("member");
    console.log(this.member);
    connectSSE(this.member.id)
  },
  methods: {
    // 跳转到目标页面
    goTargetPage(target) {
      if (target === 'checkStock') {
        this.$toast.fail("功能待开发");
      } else {
        this.$router.push("/" + target);
      }
    },
    // 退出登录
    onMemberOut() {
      StorageUtil.removeLocalStorage("member");
      this.$router.push("/login");
    },
  },
  onUnMount() {
    closeSSE()
  }
};
</script>

<style lang="scss" scoped>
.header {
  flex-wrap: wrap;
  align-content: center;
  position: relative;
  height: 6rem;
  background-color: #dc6350;
  color: white;

  .login-out {
    position: absolute;
    top: 0.8rem;
    right: 0.8rem;

    i {
      font-size: 1.4rem;
    }
  }

  section {
    display: flex;
    width: 100%;
    justify-content: center;
    line-height: 1.5rem;

    img {
      width: 3rem;
      height: 3rem;
      border-radius: 2.5rem;
    }
  }
}

.function-content {
  flex-wrap: wrap;
  border-bottom: 0.2rem solid #f0f0f0;

  .content-title {
    display: flex;
    width: 100%;
    justify-content: center;
    height: 3rem;
    align-items: center;
    font-weight: 900;
    margin-top: 0.5rem;
  }

  .content-main {
    display: flex;
    width: 100%;
    padding: 0.5rem 1rem 1.5rem 1rem;
    justify-content: space-around;

    section {
      display: inline-flex;
      width: 40%;
      justify-content: center;
      flex-wrap: wrap;
      color: white;
      background-color: #dc6350;
      border-radius: 0.5rem;
      align-items: center;
      padding-top: 0.3rem;

      span {
        display: flex;
        width: 100%;
        justify-content: center;
        height: 2.3rem;
        align-items: center;
        font-size: 0.95rem;

        i {
          font-size: 2rem;
          color: white;
        }
      }
    }
  }
}

.tools {
  flex-wrap: wrap;

  .content-title {
    display: flex;
    width: 100%;
    justify-content: center;
    height: 2rem;
    align-items: center;
    font-weight: 900;
    margin-top: 0.5rem;
  }

  .content-main {
    display: flex;
    width: 100%;
    padding: 0 0.5rem;
    flex-wrap: wrap;

    section {
      display: inline-flex;
      width: 33.33%;
      align-items: center;
      padding: 0.8rem;
      justify-content: center;

      .tool-item {
        display: inline-flex;
        flex-wrap: wrap;
        background-color: #dc6350;
        border-radius: 0.3rem;
        padding: 1rem;

        span {
          display: flex;
          width: 100%;
          justify-content: center;
          font-size: 0.9rem;
          color: white;

          i {
            font-size: 2rem;
            margin-bottom: 0.3rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue